module.exports = __webpack_public_path__ + "img/95.c1eafe29.jpg";